export enum OpenAppEnum {
  PLAY = 'PLAY',
  JOIN = 'JOIN',
  DOWNLOAD = 'DOWNLOAD',
  ACCEPT = 'ACCEPT'
}
